import React from 'react';
import clsx from 'clsx';
import BannerMedia from './banner-media';
import { IBanner } from './Ibanner';

const Banner = ({
  className,
  banner_style,
  media,
  enableMobileStack,
  layout,
  cardLayout,
  children,
  cardStyle,
  mediaStyle,
  productType,
  alt,
  ...props
}: IBanner): JSX.Element => {
  return (
    <div
      data-testid="banner-test"
      className={clsx(
        'flex relative',
        {
          'flex-col xl:flex-row': enableMobileStack,
        },
        className
      )}
      {...props}
    >
      {/*BannerMedia Component */}
      <div
        className={clsx('flex w-full ', {
          'justify-start': layout === 'left-facing',
          'justify-center': layout === 'center-facing',
          'justify-end': layout === 'right-facing',
        })}
      >
        <BannerMedia imageUrl={media as string} layout={layout} mediaStyle={mediaStyle} alt={alt} productType={productType}/>
      </div>
      {/*Tile Component */}
      {children && (
        <div
          className={clsx(
            'flex w-full xl:absolute xl:self-center',
            {
              'justify-start': cardLayout === 'left-facing',
              'justify-center': cardLayout === 'center-facing',
              'justify-end': cardLayout === 'right-facing',
              'absolute self-center ': !enableMobileStack,
            },
            cardStyle
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
};
export default Banner;
